<template>
  <div class="body-fluid">
    <el-form ref="form" label-posittion="left" label-width="120px" :model="model">
      <el-row>
        <el-col :span="14">
          <el-form-item
            label="影片渠道"
            prop="channelList"
            :rules="[
              { type: 'array', required: true, message: '请选择影片渠道' }
            ]"
          >
            <el-select v-model="model.channelList" clearable multiple collapse-tags @clear="checkChannelAll = false">
              <el-checkbox
                v-model="checkChannelAll"
                class="checkbox-in-select"
                :indeterminate="model.channelList.length > 0 && model.channelList.length < channelOpts.length"
                @change="checkAllChannelChange"
              >全选</el-checkbox>
              <el-option
                v-for="(channel, index) in channelOpts"
                :key="index"
                :value="channel.key"
                :label="channel.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item
            label="影片分类"
            prop="categoryList"
            :rules="[
              { type: 'array', required: true, message: '请选择影片分类' }
            ]"
          >
            <el-select v-model="model.categoryList" clearable multiple collapse-tags @clear="checkCategoryAll = false">
              <el-checkbox
                v-model="checkCategoryAll"
                class="checkbox-in-select"
                :indeterminate="model.categoryList.length > 0 && model.categoryList.length < categoryOpts.length"
                @change="checkAllCategoryChange"
              >全选</el-checkbox>
              <el-option
                v-for="(cate, index) in categoryOpts"
                :key="index"
                :value="cate.key"
                :label="cate.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="演员">
            <el-select v-model="model.actorType">
              <el-option value="in" label="任意包含"></el-option>
              <el-option value="allin" label="全部包含"></el-option>
              <el-option value="notin" label="不包含"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="offline-col">
          <el-form-item label-width="0">
            <el-input v-model="model.actor" placeholder="多个以英文逗号隔开" @change="inputActor"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="标签">
            <el-select v-model="model.tagType">
              <el-option value="in" label="任意包含"></el-option>
              <el-option value="allin" label="全部包含"></el-option>
              <el-option value="notin" label="不包含"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="offline-col">
          <el-form-item label-width="0">
            <el-input v-model="model.tag" placeholder="多个以英文逗号隔开" @change="inputTag"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item label="影片名称">
            <el-input v-model="model.title" placeholder="请输入影片名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="上映时间">
            <el-select v-model="model.releaseTimeType">
              <el-option :value="0" label="大于"></el-option>
              <el-option :value="1" label="大于等于"></el-option>
              <el-option :value="2" label="小于"></el-option>
              <el-option :value="3" label="小于等于"></el-option>
              <el-option :value="4" label="等于"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="offline-col">
          <el-form-item label-width="0">
            <el-date-picker v-model="model.releaseTime" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item
            label="榜单数量"
            prop="topNumber"
            :rules="[
              { required: true, message: '请填写榜单数量', trigger: 'blur' }
            ]"
          >
            <el-input type="number" v-model="model.topNumber" @keyup.enter="handleSearch" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="查询时间"
            prop="queryDate"
            :rules="[
              { type: 'array', required: true, message: '请选择查询日期', trigger: 'blur' }
            ]"
          >
            <el-date-picker
              v-model="model.queryDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="{
                disabledDate: disabledDate
              }"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="search-nav">
      <div class="search-nav-left">
        <el-radio-group v-model="model.showBy">
          <el-radio-button :label="1">分天展示</el-radio-button>
          <el-radio-button :label="0">合并展示</el-radio-button>
        </el-radio-group>
        <el-button type="primary" icon="el-icon-search" :loading="searchLoading" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
      </div>
      <el-select v-model="checkedColumns" multiple placeholder="" class="op-select">
        <i slot="prefix" class="el-icon-setting"></i>
        <el-option v-for="(column, index) in columns" :key="index" :value="column.prop" :label="column.label"></el-option>
      </el-select>
    </div>
    <div class="table-panel">
      <el-table
        ref="videoTable"
        :loading="searchLoading"
        :data="tableData"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          v-for="(column, index) in displayColumns"
          :key="index"
          :label="column.label"
          :prop="column.prop"
          :width="column.width"
          :show-overflow-tooltip="true"
        />
      </el-table>
    </div>
    <div class="operate-nav">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="handleSelectData">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      checkedData: [],
      searchLoading: false,
      model: this.initModel(),
      videoCategories: [],
      channelOpts: [],
      categoryOpts: [],
      checkCategoryAll: false,
      checkChannelAll: false,
      columns: [
        { prop: 'dt', label: '时间', width: '160' },
        { prop: 'title', label: '影片名称', width: '200' },
        { prop: 'alias', label: '别名', width: '200' },
        { prop: 'coocaaVId', label: '酷开VID', width: '200' },
        { prop: 'thirdId', label: '第三方VID', width: '200' },
        { prop: 'categoryName', label: '影片分类', width: '160' },
        { prop: 'sourceName', label: '影片渠道', width: '160' },
        { prop: 'vipPv', label: 'vip起播量', width: '160' },
        { prop: 'nonVipPv', label: '非vip起播量', width: '160' },
        { prop: 'pv', label: '总起播量', width: '160' },
        { prop: 'actor', label: '演员', width: '160' },
        { prop: 'isTvod', label: '是否点播视频', width: '120' },
        { prop: 'isVip', label: '是否会员视频', width: '120' },
        { prop: 'tag', label: '标签', width: '160' },
        { prop: 'releaseTime', label: '上映时间', width: '160' },
        { prop: 'modifyTime', label: '更新时间', width: '160' },
        { prop: 'createdTime', label: '创建时间', width: '160' }
      ],
      checkedColumns: ['dt', 'title', 'alias', 'categoryName', 'coocaaVId', 'thirdId', 'sourceName', 'vipPv', 'nonVipPv', 'pv', 'tag']
    }
  },
  computed: {
    displayColumns() {
      return this.columns.filter(column => {
        return this.checkedColumns.includes(column.prop)
      })
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$service.getVideoConditions().then(res => {
        this.categoryOpts = res.categoryList || []
        this.channelOpts = res.channelList
      })
    },
    initModel() {
      return {
        channelList: [],
        categoryList: [],
        topNumber: undefined,
        queryDate: [],
        vid: '',
        title: '',
        releaseTimeType: 1,
        releaseTime: '',
        actorType: 'in',
        actor: '',
        tagType: 'in',
        tag: '',
        showBy: 0
      }
    },
    // 重置
    handleReset() {
      this.model = this.initModel()
    },
    inputActor() {
      this.model.actor = this.model.actor.replace(/[(，)|(/\s+/)]/g, ',')
    },
    inputTag() {
      this.model.tag = this.model.tag.replace(/[(，)|(/\s+/)]/g, ',')
    },
    // 拼装参数
    buildQueryParam() {
      const params = this.cloneDeep(this.model)
      if (params.actor === '') {
        params.actor = undefined
        params.actorType = undefined
      }
      if (params.tag === '') {
        params.tag = undefined
        params.tagType = undefined
      }
      if (params.releaseTime === '') {
        params.releaseTime = undefined
        params.releaseTimeType = undefined
      }
      if (params.queryDate) {
        params.beginDate = params.queryDate[0]
        params.endDate = params.queryDate[1]
        delete params.queryDate
      }
      return params
    },
    // 查询
    async handleSearch() {
      if (!(await this.$refs.form.validate())) {
        return
      }
      const params = this.buildQueryParam()
      this.searchLoading = true
      this.$service.getVideoTopList(params)
        .then(res => {
          this.searchLoading = false
          this.tableData = res || []
          this.checkedData = []
        })
        .catch(() => {
          this.searchLoading = false
        })
    },
    handleSelectionChange(selection) {
      this.checkedData = this.cloneDeep(selection)
    },
    // 勾选
    handleSelectData() {
      this.$emit('data-select', this.checkedData)
      this.$emit('close')
    },
    checkAllCategoryChange(checked) {
      if (checked) {
        this.model.categoryList = this.categoryOpts.map(item => item.key)
      } else {
        this.model.categoryList = []
      }
    },
    checkAllChannelChange(checked) {
      if (checked) {
        this.model.channelList = this.channelOpts.map(item => item.key)
      } else {
        this.model.channelList = []
      }
    },
    disabledDate(date) {
      return date > new Date().getTime() - 8.64e7
    }
  }
}
</script>

<style lang="stylus" scoped>
.offline-col
  .el-select
    width 8rem
.search-nav
  display flex
  justify-content space-between
  margin 10px 0
  .el-button
    margin-left 20px
.operate-nav
  display flex
  justify-content flex-end
  padding-top 30px
  .el-btn
    margin-left 20px
    width 80px
.el-table
  border-right 1px solid #eee
.op-select
  width 60px!important
  height 36px
  cursor pointer
  >>>.el-input.is-focus .el-input__inner
    border-color #eee
  >>>.el-select__tags
    display none
  >>>.el-input__prefix
    line-height 36px
    padding-left 20px
    font-size 16px
  >>>.el-input__suffix
    display none
.search-nav-left
  display flex
  flex-flow row nowrap
.checkbox-in-select
  padding 4px 18px 8px
  width calc(100% - 36px)
</style>
